import { downloadBlob } from '@/shared/lib/export-utils';
import type { AuditTrailItem } from '@skewb-works/contracts';
import {
  describeAuditEvent,
  formatEntityType,
  formatEventType,
  formatTimestamp,
} from './auditTrailFormatters';

function escapeCsvField(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

const CSV_HEADER = 'Timestamp,User,Event Type,Entity,Description,Reason';

export function formatAuditTrailCsv(items: AuditTrailItem[]): string {
  const rows = items.map((item) => {
    const fields = [
      formatTimestamp(item.created_at),
      item.username,
      formatEventType(item.event_type),
      `${formatEntityType(item.entity_type)} #${item.entity_id}`,
      describeAuditEvent(item),
      item.reason ?? '',
    ];
    return fields.map(escapeCsvField).join(',');
  });

  return [CSV_HEADER, ...rows].join('\n');
}

export function formatAuditTrailJson(items: AuditTrailItem[]): string {
  return JSON.stringify(items, null, 2);
}

/** @deprecated Use `downloadBlob` from `@/shared/lib/export-utils` directly. */
export function downloadFile(content: string, filename: string, mimeType: string): void {
  downloadBlob(content, filename, mimeType);
}
